export const SparklesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_5062_11215)">
      <path
        d="M13.5006 2.10156C13.6728 2.10156 13.8256 2.21173 13.8801 2.37506L13.9057 2.45204C14.1645 3.22841 14.7737 3.83763 15.5501 4.09642L15.6271 4.12208C15.7904 4.17653 15.9006 4.32938 15.9006 4.50156C15.9006 4.67373 15.7904 4.82658 15.6271 4.88103L15.5501 4.90669C14.7737 5.16548 14.1645 5.7747 13.9057 6.55107L13.8801 6.62805C13.8256 6.79138 13.6728 6.90156 13.5006 6.90156C13.3284 6.90156 13.1756 6.79138 13.1211 6.62805L13.0955 6.55107C12.8367 5.7747 12.2275 5.16548 11.4511 4.90669L11.3741 4.88103C11.2108 4.82658 11.1006 4.67373 11.1006 4.50156C11.1006 4.32938 11.2108 4.17653 11.3741 4.12208L11.4511 4.09642C12.2275 3.83763 12.8367 3.22841 13.0955 2.45204L13.1211 2.37506C13.1756 2.21173 13.3284 2.10156 13.5006 2.10156Z"
        fill="url(#paint0_linear_5062_11215)" />
      <path
        d="M8.5 4.00146C8.72943 4.00146 8.92943 4.15761 8.98507 4.38019L9.11195 4.88772C9.60459 6.85827 11.1432 8.39689 13.1137 8.88954L13.6213 9.01643C13.8439 9.07208 14 9.27207 14 9.50151C14 9.73094 13.8438 9.93093 13.6213 9.98658L13.1138 10.1135C11.1432 10.6061 9.60458 12.1447 9.11194 14.1153L8.98507 14.6228C8.92943 14.8454 8.72943 15.0015 8.5 15.0015C8.27057 15.0015 8.07057 14.8454 8.01493 14.6228L7.88806 14.1153C7.39542 12.1447 5.85676 10.6061 3.88617 10.1135L3.37874 9.98658C3.15615 9.93093 3 9.73094 3 9.50151C3 9.27207 3.15614 9.07208 3.37873 9.01643L3.88626 8.88954C5.85681 8.39689 7.39541 6.85827 7.88805 4.88772L8.01493 4.38019C8.07057 4.15761 8.27057 4.00146 8.5 4.00146Z"
        fill="url(#paint1_linear_5062_11215)" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_5062_11215" x1="3" y1="13.7473" x2="17.7697" y2="11.8816"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#0021FF" />
        <stop offset="0.65" stopColor="#116DFF" />
        <stop offset="0.96" stopColor="#5FF2AE" />
      </linearGradient>
      <linearGradient id="paint1_linear_5062_11215" x1="3" y1="13.7473" x2="17.7697" y2="11.8816"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#0021FF" />
        <stop offset="0.65" stopColor="#116DFF" />
        <stop offset="0.96" stopColor="#5FF2AE" />
      </linearGradient>
      <clipPath id="clip0_5062_11215">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
